const json = require('../assets/config/colors.json')

export const getColor = (name) => {
  return json[name]
}
